import {Platform, StyleSheet} from 'react-native';

import {black, cloud, grayscale, greyf7, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 4,
    gap: 10,
    backgroundColor: greyf7,
    height: 44,
    width: '100%',
    marginTop: 6,
    justifyContent: 'flex-start',
  },
  resultsText: {
    flex: 1,
    maxWidth: 379,
    fontSize: 14,
    color: black,
  },
  sortButton: {
    marginLeft: 'auto',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    gap: 8,
    height: 32,
    backgroundColor: white,
    borderWidth: 1,
    borderColor: cloud,
    borderRadius: 8,
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
  sortButtonText: {
    fontSize: 13,
    color: black,
    flex: 1,
  },
  sortIcon: {
    fontSize: 14,
    color: grayscale,
    flexShrink: 0,
  },
});
